class Point {
	x = 0;

	y = 0;

	constructor(x, y) {
		this.x = x;
		this.y = y;
	}

	distanceFrom(point) {
		return Math.hypot(this.x - point.x, this.y - point.y);
	}
}

export default Point;
